import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import { CommonBindingDataService } from './../services/common-binding-data.service';
@Directive({
  selector: '[appAccessProvider]'
})
export class AccessProviderDirective implements OnChanges {
  @Input() accessCode;
  private _el: HTMLElement;
  private menuAccessList: any[];

  constructor(el: ElementRef, private commonBindingDataService: CommonBindingDataService) {
    this._el = el.nativeElement;
  }

  ngOnChanges() {
    this.menuAccessList = this.commonBindingDataService.getSelectedMenuAccessesList();
    this.menuAccessList = this.menuAccessList === null ? [] : this.menuAccessList;
    const hasAccess = this.menuAccessList.find((elm) => {
      // return elm.id === this.accessCode;
      return elm.accessCode === this.accessCode;
    });
    if (!hasAccess) {
      this._el.style.display = 'none';
    }
  }
}
